import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var PbcListSvg = function PbcListSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F96800",
    d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M16.167 14.5a.833.833 0 0 1 0 1.667h-5a.833.833 0 1 1 0-1.667zm-8.334 0a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667m8.334-3.333a.833.833 0 0 1 0 1.667h-5a.833.833 0 1 1 0-1.667zm-8.334 0a.833.833 0 1 1 0 1.667.833.833 0 0 1 0-1.667m8.334-3.333a.833.833 0 0 1 0 1.666h-5a.833.833 0 1 1 0-1.666zm-8.334 0a.833.833 0 1 1 0 1.666.833.833 0 0 1 0-1.666",
    clipRule: "evenodd"
  }));
};
export var PbcList = function PbcList(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: PbcListSvg
  }));
};